import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isNil } from 'ramda';
import { UnifiedPrivacy } from '@prezi/presentation-service-client';
import { unifiedPrivacyActions } from '../../../store/actions/unifiedPrivacyActions';
import { isPermissionNotAllowedInOrg, isPermissionNotAllowedWithCurrentLicense } from '../../../api/userPermissions';
import { Dumb } from '../';
import { getDisabledControlContext, getPaywallControlContext } from '../dumb/TogglePublic/getControlContext';
import { documentToProductName } from '../../../utils/mappings';
const calculatePublicControlContext = (unifiedPrivacy, userPermissions, document) => {
  if (!unifiedPrivacy.is_owner) {
    return getDisabledControlContext('notAllowedShared');
  }
  const isClosedPrivacy = unifiedPrivacy.unified_privacy === UnifiedPrivacy.unified_privacy.CLOSED;
  if (isClosedPrivacy) {
    return getDisabledControlContext('notAllowedClosedPrivacy');
  }
  const unifiedPrivacyPermissions = userPermissions.unifiedPrivacy.set.open;
  if (isPermissionNotAllowedWithCurrentLicense(unifiedPrivacyPermissions === null || unifiedPrivacyPermissions === void 0 ? void 0 : unifiedPrivacyPermissions.unPublished.reusable) || isPermissionNotAllowedWithCurrentLicense(unifiedPrivacyPermissions === null || unifiedPrivacyPermissions === void 0 ? void 0 : unifiedPrivacyPermissions.unPublished.copyrighted)) {
    return getPaywallControlContext('notAllowedWithCurrentLicense', documentToProductName(document));
  }
  if (isPermissionNotAllowedInOrg(unifiedPrivacyPermissions === null || unifiedPrivacyPermissions === void 0 ? void 0 : unifiedPrivacyPermissions.published.reusable) || isPermissionNotAllowedInOrg(unifiedPrivacyPermissions === null || unifiedPrivacyPermissions === void 0 ? void 0 : unifiedPrivacyPermissions.published.copyrighted)) {
    return getDisabledControlContext('notAllowedInOrg');
  }
  return {
    disabled: false
  };
};
const TogglePublic = () => {
  const dispatch = useDispatch();
  const [unifiedPrivacy, userPermissions, document] = useSelector(state => [state.unifiedPrivacy.value, state.userPermissions.value, state.document.value]);
  if (isNil(unifiedPrivacy) || isNil(userPermissions) || isNil(document)) {
    return null;
  }
  const controlContext = calculatePublicControlContext(unifiedPrivacy, userPermissions, document);
  return React.createElement(Dumb.TogglePublic, {
    controlContext: controlContext,
    checked: unifiedPrivacy.is_published,
    handleOnChange: newValue => dispatch(unifiedPrivacyActions.setPublished(newValue))
  });
};
export default TogglePublic;